import { render, staticRenderFns } from "./RolePermissionEdit.vue?vue&type=template&id=4210cd3e&scoped=true&"
import script from "./RolePermissionEdit.vue?vue&type=script&lang=js&"
export * from "./RolePermissionEdit.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionEdit.vue?vue&type=style&index=0&id=4210cd3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210cd3e",
  null
  
)

export default component.exports